/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, isDevMode } from '@angular/core';

export enum LogLevel {
  Log = 'log',
  Warn = 'warn',
  Error = 'error',
  Debug = 'debug'
}

@Injectable()
export class LoggerService {
  protected _isDev: boolean;

  private _styles: Record<LogLevel, string> = {
    log: 'background: #3B82F6; color: white; padding: 2px 4px; border-radius: 2px;',
    warn: 'background: #F59E0B; color: white; padding: 2px 4px; border-radius: 2px;',
    error:
      'background: #EF4444; color: white; padding: 2px 4px; border-radius: 2px;',
    debug:
      'background: #10B981; color: white; padding: 2px 4px; border-radius: 2px;'
  };

  constructor() {
    this._isDev = isDevMode();
  }

  /**
   * Logs a message to the console in development mode with blue background.
   * @param message The message to log
   * @param args Additional arguments to include in the log
   */
  log(message?: any, ...optionalParams: any[]): void {
    if (this._isDev) {
      console.log(`%c[LOG]`, this._styles.log, message, ...optionalParams);
    }
  }

  /**
   * Logs a warning to the console in development mode with amber background.
   * @param message The warning message
   * @param args Additional arguments to include in the warning
   */
  warn(message?: any, ...optionalParams: any[]): void {
    if (this._isDev) {
      console.warn(`%c[WARN]`, this._styles.warn, message, ...optionalParams);
    }
  }

  /**
   * Logs an error to the console in development mode with red background.
   * @param message The error message
   * @param args Additional arguments to include in the error
   */
  error(message?: any, ...optionalParams: any[]): void {
    if (this._isDev) {
      console.error(
        `%c[ERROR]`,
        this._styles.error,
        message,
        ...optionalParams
      );
    }
  }

  /**
   * Logs a debug message to the console in development mode with green background.
   * @param message The debug message
   * @param args Additional arguments to include in the debug log
   */
  debug(message?: any, ...optionalParams: any[]): void {
    if (this._isDev) {
      console.debug(
        `%c[DEBUG]`,
        this._styles.debug,
        message,
        ...optionalParams
      );
    }
  }
}
